import axios from '@axios'

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        list: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('institutions', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        // show: (cntx, { id }) => {
        //     axios.get(`institutions/${id}`)
        //         .then(response => resolve(response))
        //         .catch(error => reject(error))
        // },
        show: (cntx, { id }) => new Promise((resolve, reject) => {
            axios.get(`institutions/${id}`)
                .then(response => {
                    resolve(response)
                })
                .catch(error => reject(error))
        }),
        create: (cntx, params) => new Promise((resolve, reject) => {
            axios.post('institutions', params)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        update: (cntx, params) => new Promise((resolve, reject) => {
            axios.put(`institutions/${params.id}`, params.data)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        remove: (cntx, id) => new Promise((resolve, reject) => {
            axios.delete(`institutions/${id}`)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        levies: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('levies', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        currencies: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('currencies', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        banks: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('banks', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        packages: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('packages', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),

        deductibles: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('deductibles', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        listLoans: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('loans', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),

        createLoan: (cntx, params) => new Promise((resolve, reject) => {
            axios.post('loans', params)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        updateLoan: (cntx, params) => new Promise((resolve, reject) => {
            axios.put(`loans/${params.id}`, params.data)
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
    },
}
